import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-335c93df"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pencil text-xs" }
const _hoisted_2 = { class: "count text-gray-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["category flex-center-between cursor-pointer mt-2", {rename: _ctx.rename}])
  }, [
    (_ctx.isModer)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleRename && _ctx.toggleRename(...args))),
          class: "mr-2"
        }, [
          _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.rename ? "✓" : "✏️"), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["main flex-center mx-1 lg:mx-0 lg:mr-2 py-1 bg-gray-200 px-1 rounded pr-2", {'bg-green-400': _ctx.$route.params.category ? _ctx.$route.params.category === _ctx.category?.id : +(_ctx.category?.id || -1) === -1}]),
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.activate && _ctx.activate(...args)))
    }, [
      _createVNode(_component_InputText, {
        type: "text",
        value: _ctx.name,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.name) = $event)),
        disabled: !_ctx.rename,
        class: "category-input cursor-pointer flex-grow",
        onEnd: _ctx.toggleRename
      }, null, 8, ["value", "disabled", "onEnd"]),
      _createElementVNode("div", _hoisted_2, "(" + _toDisplayString(_ctx.category?.count) + ")", 1)
    ], 2),
    (_ctx.isModer)
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('del')))
        }, "✕"))
      : _createCommentVNode("", true)
  ], 2))
}